import { useDispatch } from "react-redux";
import { notice } from "../../redux/action/action";
import { Input } from "semantic-ui-react";

const InputCopy = ({ copyLink, setComfirmCopy }) => {
  const dispatch = useDispatch();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyLink);
      if (setComfirmCopy) {
        setComfirmCopy(true);
      }
      dispatch(notice("Copied!", "success", 20));
    } catch (error) {
      dispatch(notice("Error!", "error", 20));
    }
  };

  return (
    <>
      <Input
        action={{
          icon: "clone",
          circular: true,
          link: true,
          className:
            "!bg-icon-background !text-base-light-white dark:!text-base-light-dark copy-button",
          onClick: handleCopy,
        }}
        input={{
          className:
            "!bg-input-color dark:!bg-base-light-dark dark:!text-base-light-white border !text-transaction-text",
          disabled: true,
          readOnly: true,
        }}
        value={copyLink}
        className="rounded-[5px] w-full !border-0"
      />
    </>
  );
};

export default InputCopy;
